import * as THREE from 'three';
import sceneHelpers from '@vfdp-customs/customs-scene-helpers';
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
const { VUE_APP_PUBLIC_PATH: publicPath } = process.env;

export default {
  install(Vue) {
    const sceneInstance = new sceneHelpers({ THREE }).sceneHelpers;

    Vue.prototype.$model3D = {
      sceneHelpers: sceneInstance,
      objLoader: new GLTFLoader(),
      dracoLoader: new DRACOLoader(),
      rootObj: {},
      modelObj: {},
      defaultMeshOptions: {},
      browserIsValid: null,

      setProperty({ property, value }) {
        if (!property || typeof property !== 'string') {
          console.error('model3D - setProperty: property is not correctly defined');
          return;
        }
        if (!value) {
          console.error('model3D - setProperty: value is not correctly defined');
          return;
        }

        this[property] = value;
      },
      setSubProperty({ property, subproperty, value }) {
        if (!property || typeof property !== 'string') {
          console.error('model3D - setSubProperty: property is not correctly defined');
          return;
        }
        if (!subproperty || typeof subproperty !== 'string') {
          console.error('model3D - setSubProperty: subproperty is not correctly defined');
          return;
        }
        if (!value) {
          console.error('model3D - setSubProperty: value is not correctly defined');
          return;
        }
        if (!this[property]) {
          console.error(`model3D - setSubProperty: property ${ property } does not exist`);
          return;
        }

        this[property][subproperty] = value;
      },
      initDracoDecoder({domain, env}) {
        const decoderPath = `draco/gltf/`;
        this.dracoLoader.setDecoderPath(decoderPath);
        this.dracoLoader.setWorkerLimit(1);
        this.objLoader.setDRACOLoader(this.dracoLoader);
      },
      loadObject(url) {
        return new Promise(resolve => {
          this.objLoader.load(url, obj => {
            const modelObj = obj.scene;
            resolve(modelObj);
          });
        });
      },
      /**
       * @function loadTexture
       * @param {Object} data - Data object that contains the information needed to load a teture from s3(url, type, etc.)
       * Using sceneHelpers loads a texture from s3 into local memory.
       */
      loadTexture(data) {
        return new Promise((resolve, reject) => {
          if (data && typeof data.image_url === "string") {
            const { loader } = this.sceneHelpers.getTextureLoader({ manager: data.manager });
            this.sceneHelpers.loadTexture({ path: data.image_url, options: data.options, textureLoader: loader })
              .then(texture => {
                texture.flipY = false;
                resolve(texture, data.componentName)
              })
              .catch(err => {
                console.error("Error Applying Texture:", err);
                reject(err);
              });
          } else {
            reject("Texture Url was not found");
          }
        });
      },
      /**
       * @function  loadTextures
       * @param {Object} textureList
       * Load textures from list
       */
      loadMultipleTextures(textureList) {
        const textureKeys = Object.keys(textureList);
        const promises = textureKeys.map(name => (
          this.loadTexture(textureList[name]).then(texture => ({ name, texture }))
        ));

        return Promise.all(promises).then(texturesArray => {
          const textures = {};
          texturesArray.forEach(({ name, texture }) => textures[name] = texture);
          return textures;
        }).catch(err => console.log('loadMultipleTextures: ', err));
      },

      /**
       * @function isValidBrowser
       * Method that validate if the browser is IE > 11 and Webgl.
       */
      isValidBrowser() {
        if(this.browserIsValid) return this.browserIsValid;
        const canvas = document.createElement( 'canvas' );
        let ua = window.navigator.userAgent;
        const trident = ua.indexOf('Trident/');
        let IEValid = true;
        const isWebgl = !! ( window.WebGLRenderingContext && ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' ) ) );

        if (trident > 0) {
          // IE 11 => return version number
          const rv = ua.indexOf('rv:');
          IEValid = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) > 11 ? true : false;
        }

        if(!isWebgl || !IEValid) {
          this.browserIsValid = false;
          return false;
        }
        this.browserIsValid = true;
        return true;
      }
    };
  }
};
